import { Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import Login from "../modules/login/Login";
import HomePage from "../modules/home/HomePage";
import Users from "../modules/users/Users";
import NewUser from "../modules/users/NewUser";
import InProgressEntries from "../modules/entries/InProgressEntries";
import CompletedEntries from "../modules/entries/CompletedEntries";
import ActivateAccount from "../modules/users/ActivateAccount";
import EditUser from "../modules/users/EditUser";
import EntryDetailedView from "../modules/entries/EntryDetailedView";
import ActiveReviews from "../modules/reviews/ActiveReviews";
import CompletedReviews from "../modules/reviews/CompletedReviews";
import ReviewDetailedView from "../modules/reviews/ReviewDetailedView";
import { AuditEventsLog } from "../modules/audit/AuditEventsLog";
import { MailLog } from "../modules/mail/MailLog";
import UserProfile from "../modules/profile/UserProfile";
import ReviewsForSigning from "../modules/reviews/ReviewForSigning";
import ReviewsForArchiving from "../modules/reviews/ReviewsForArchiving";
import ReviewsForAssignment from "../modules/reviews/ReviewsForAssignment";
import { ReviewAssignmentView } from "../modules/reviews/ReviewAssignmentView";
import AssignedReviews from "../modules/reviews/AssignedReviews";

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<></>}>
            <HomePage />
          </Suspense>
        }
      />
      <Route
        path="/users"
        element={
          <Suspense fallback={<></>}>
            <Users />
          </Suspense>
        }
      >
        <Route
          path="new"
          element={
            <Suspense fallback={<></>}>
              <NewUser />
            </Suspense>
          }
        />
        <Route
          path="edit/:id"
          element={
            <Suspense fallback={<></>}>
              <EditUser />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="/profile"
        element={
          <Suspense fallback={<></>}>
            <UserProfile />
          </Suspense>
        }
      />
      <Route
        path="/entries/details/:id"
        element={
          <Suspense fallback={<></>}>
            <EntryDetailedView />
          </Suspense>
        }
      />
      <Route
        path="/entries/progress"
        element={
          <Suspense fallback={<></>}>
            <InProgressEntries />
          </Suspense>
        }
      />
      <Route
        path="/entries/completed"
        element={
          <Suspense fallback={<></>}>
            <CompletedEntries />
          </Suspense>
        }
      />
      <Route
        path="/reviews/forsigning"
        element={
          <Suspense fallback={<></>}>
            <ReviewsForSigning />
          </Suspense>
        }
      />
      <Route
        path="/reviews/active"
        element={
          <Suspense fallback={<></>}>
            <ActiveReviews />
          </Suspense>
        }
      />
      <Route
        path="/reviews/assigned"
        element={
          <Suspense fallback={<></>}>
            <AssignedReviews />
          </Suspense>
        }
      />
      <Route
        path="/reviews/archiving"
        element={
          <Suspense fallback={<></>}>
            <ReviewsForArchiving />
          </Suspense>
        }
      />
      <Route
        path="/reviews/assignment"
        element={
          <Suspense fallback={<></>}>
            <ReviewsForAssignment />
          </Suspense>
        }
      />
      <Route
        path="/reviews/completed"
        element={
          <Suspense fallback={<></>}>
            <CompletedReviews />
          </Suspense>
        }
      />
      <Route
        path="/reviews/assignment/:id"
        element={
          <Suspense fallback={<></>}>
            <ReviewAssignmentView />
          </Suspense>
        }
      />
      <Route
        path="/reviews/details/:id"
        element={
          <Suspense fallback={<></>}>
            <ReviewDetailedView />
          </Suspense>
        }
      />
      <Route
        path="/login"
        element={
          <Suspense fallback={<></>}>
            <Login />
          </Suspense>
        }
      />
      <Route
        path="/set-password"
        element={
          <Suspense fallback={<></>}>
            <ActivateAccount />
          </Suspense>
        }
      />

      {/* Admin Routes */}
      <Route
        path="/auditEventsLog"
        element={
          <Suspense fallback={<></>}>
            <AuditEventsLog />
          </Suspense>
        }
      />
      <Route
        path="/mailLog"
        element={
          <Suspense fallback={<></>}>
            <MailLog />
          </Suspense>
        }
      />
    </Routes>
  );
}
